import { forwardRef, ComponentProps } from "react";

const TriangleIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>((props, svgRef) => (
  <svg
    {...props}
    ref={svgRef}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
  >
    <path d="M7 11L0.0717973 0.499999L13.9282 0.5L7 11Z" fill="black" />
  </svg>
));

TriangleIcon.displayName = "TriangleIcon";

export default TriangleIcon;
